export const formatRole = (str = "") => {
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (char) => char.toUpperCase());
};

export const formatRoleFitness = (value = "") => {
  if (!value) return "";

  let formatted = value
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());

  // Fix known spelling issues
  formatted = formatted.replace(/Fitness Center/gi, "Fitness Centre");

  return formatted;
};
